import React, { useEffect, useState, useRef } from "react";
import { Div } from "../../../../../registroMaternidad/modales/components/Components";
import InputText from "../../../../../../components/modalComponents/InputText";
import InputSelect from "../../../../../../components/modalComponents/InputSelect";
import InputTextArea from "../../../../../../components/modalComponents/InputTextArea";
import { usePropsInputs } from "../../../../../../hooks/useProps/usePropsInput";
import { usePropsSelect } from "../../../../../../hooks/useProps/usePropsSelect";
import { useGetOptionsSelect } from "../../../../../../hooks/useGetOptionsSelect/useGetOptionsSelect";
import { useManagePostRequest } from "../../../../../../hooks/useManagePostRequest/useManagePostRequest";
import {handleFind, initialAllOptionPromises, isNullOrUndefinded} from "../../../../../../helper/utils";
import {
    cuadroRequerimientosGetTiposCaso,
    cuadroRequerimientosGetTiposReferencia,
    cuadroRequerimientosGetFiltrosEstados,
    cuadroRequerimientosBuscarDocentes,
    cuadroRequerimientosBuscarColaboradores,
    cuadroRequerimientosBuscarCursos,
    cuadroRequerimientosGetResponsableToCreateCasoAPI, cuadroRequerimientosGetGradosByIdCuadroSede,
    cuadroRequerimientosGetNroSeccionesByGradoAPI, cuadroRequerimientosGetCuadroBloquesSinAsignacion,
    cuadroRequerimientosBuscarSoloDocentesSinAsignacion,
} from "../../../../../../consumers/backendApisUrls";
import {CASO_KEYS, TIPO_CASOS, TIPO_REFERENCIA} from "./casoKeys";
import Select from "react-select";
import {estados} from "../../../../../../constants/states";
import InputNumber from "../../../../../../components/modalComponents/InputNumber";

const KEYS_DROPDOWN = [
  CASO_KEYS.TipoCaso,
  CASO_KEYS.TipoReferencia,
  CASO_KEYS.EstadoCaso,
];

const selectReferenciaStyle = {
  container: (base) => ({ ...base, width: "100%" }),
  control: (base) => ({
    ...base,
    fontSize: "13px",
    borderColor: "#d1d5db",
    borderRadius: "6px",
    backgroundColor: "#fafafa",
    boxShadow: "none",
    minHeight: "38px",
    "&:hover": { borderColor: "#0367A6" },
  }),
  option: (base, { isFocused }) => ({
    ...base,
    fontSize: "13px",
    backgroundColor: isFocused ? "#e8f0fe" : "white",
    color: "#333",
  }),
  placeholder: (base) => ({ ...base, fontSize: "13px", color: "#9ca3af" }),
  singleValue: (base) => ({ ...base, fontSize: "13px", color: "#333" }),
};

const useReferenciaSearch = (idCuadroSede, tipoReferencia, esTipoCargaHoraria) => {
  const [opciones, setOpciones] = useState([]);
  const [cargando, setCargando] = useState(false);
  const debounceRef = useRef(null);
  const [executeManagePost] = useManagePostRequest();

  const buscar = (criterio) => {
    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      if (!criterio || criterio.length < 2) {
        setOpciones([]);
        return;
      }
      setCargando(true);

      const esDocente = tipoReferencia === TIPO_REFERENCIA.Docente;
      const esColaborador = tipoReferencia === TIPO_REFERENCIA.Colaborador;
      const esGrado = tipoReferencia === TIPO_REFERENCIA.Grado;
      const esVacante = tipoReferencia === TIPO_REFERENCIA.Vacante;
      const esBloque = tipoReferencia === TIPO_REFERENCIA.Bloque;

      let api = ""
      if (esDocente){
          if (esTipoCargaHoraria){
              api = cuadroRequerimientosBuscarSoloDocentesSinAsignacion();
          } else {
              api = cuadroRequerimientosBuscarDocentes();
          }
      }

      else if (esColaborador)
          api = cuadroRequerimientosBuscarColaboradores();
      else if (esGrado)
          api = cuadroRequerimientosGetGradosByIdCuadroSede();
      else if (esVacante)
          api = cuadroRequerimientosGetCuadroBloquesSinAsignacion();
     else if (esBloque)
         api = cuadroRequerimientosBuscarCursos();

      await executeManagePost(
        api,
        { IdCuadroSede: idCuadroSede, Criterio: criterio },
          callBackSuccess,
        false,
      );
      setCargando(false);
    }, 350);
  };


const callBackSuccess = ({ data }) => {
    const esDocente = tipoReferencia === TIPO_REFERENCIA.Docente;
    const esColaborador = tipoReferencia === TIPO_REFERENCIA.Colaborador;
    const esGrado = tipoReferencia === TIPO_REFERENCIA.Grado;
    const esVacante = tipoReferencia === TIPO_REFERENCIA.Vacante;
    const esBloque = tipoReferencia === TIPO_REFERENCIA.Bloque;

    let mapped = []

    if (esDocente || esColaborador)
        mapped =  data.map((d) => ({
            value: d.NombreCompleto,
            label: d.NombreCompleto,
            id: d.IdEmpleado, // → IdReferenciaEntidad
        }))

    if (esGrado)
        mapped =   data.map((c) => ({
            value: c.Text,
            label: c.Text,
            id: c.Value, // → IdReferenciaEntidad
        }))

    if (esBloque)
        mapped =
            data.map((c) => ({
                value: c.Descripcion,
                label: c.Descripcion,
                id: c.IdCurso, // → IdReferenciaEntidad
            }))

    if (esVacante)
        mapped =
            data.map((c) => ({
                value: c.Text,
                label: c.Text,
                id: c.Value, // → IdReferenciaEntidad
            }))
        setOpciones(mapped);

}


  useEffect(() => {
    setOpciones([]);
  }, [tipoReferencia]);



  return { opciones, cargando, buscar };
};


const CasoFormFields = ({
  idCuadroSede,
  formValuesCaso,
  setFormValuesCaso,
  isEditable,
  SECTION_NAME,
  dataToCreateCaso
}) => {

    useEffect(() => {
        if (
            formValuesCaso[CASO_KEYS.TipoReferencia] === "Grado" &&
            !isNullOrUndefinded(formValuesCaso[CASO_KEYS.IdReferenciaEntidad])
        )
        {
            obtenerNroSecciones();

        }

    }, [formValuesCaso[CASO_KEYS.IdReferenciaEntidad]]);



    useEffect(() => {
        if (
            formValuesCaso[CASO_KEYS.TipoReferencia] === "Grado" &&
            !isNullOrUndefinded(formValuesCaso[CASO_KEYS.IdReferenciaEntidad] )&&
                !isNullOrUndefinded(formValuesCaso[CASO_KEYS.ParametroValor])
                )
        {
            let grado = formValuesCaso[CASO_KEYS.Referencia];
            let secciones = formValuesCaso[CASO_KEYS.ParametroValor];
            setFormValuesCaso(lastData => ({
                ...lastData,
                [CASO_KEYS.MensajeInicial]: "Se ha registrado un cambio en la meta comercial de la sede, la nueva cantidad de secciones para el grado "+grado+" es: "+secciones+", se debe eliminar, de ser necesario, las asignaciones involucradas en el cambio de sección y procesar el caso.",
            }));
        }

    }, [formValuesCaso[CASO_KEYS.ParametroValor]]);

    const [executeManagePost] = useManagePostRequest();
    const [responsable, setResponsable] = useState({})

    const [commonProps] = usePropsInputs(
    formValuesCaso,
    setFormValuesCaso,
    SECTION_NAME,
  );
  const [allDropdowns, setAllDropdowns] = useState([]);
  const [getOption] = useGetOptionsSelect();


  useEffect(() => {
    let isMounted = true;
    const getDropdowns = async () => {
      const dropdownsPromises = () => [
        getOption(cuadroRequerimientosGetTiposCaso()),
        getOption(cuadroRequerimientosGetTiposReferencia()),
        getOption(cuadroRequerimientosGetFiltrosEstados()),
      ];
      await initialAllOptionPromises(
        dropdownsPromises,
        KEYS_DROPDOWN,
        (data) => {
          if (isMounted) setAllDropdowns(data);
        },
      );
    };
    getDropdowns();
    return () => {
      isMounted = false;
    };
  }, []);



    useEffect(() => {
        setFormValuesCaso(lastData => ({
            ...lastData,
            [CASO_KEYS.TipoReferencia]: null,
            [CASO_KEYS.Referencia]: null,
            [CASO_KEYS.IdReferenciaEntidad]: null,
            [CASO_KEYS.ParametroValor]: null
        }));

        obtenerResponsableCaso();
    }, [formValuesCaso[CASO_KEYS.TipoCaso]]);

    useEffect(() => {
        setFormValuesCaso(lastData => ({
            ...lastData,
            [CASO_KEYS.Referencia]: null,
            [CASO_KEYS.IdReferenciaEntidad]: null,
            [CASO_KEYS.ParametroValor]: null
        }));


    }, [formValuesCaso[CASO_KEYS.TipoReferencia]]);



    const obtenerResponsableCaso = async () => {
        if (formValuesCaso[CASO_KEYS.TipoCaso]){
            const payload ={
                "TipoCaso": formValuesCaso[CASO_KEYS.TipoCaso]
            }
            const api = cuadroRequerimientosGetResponsableToCreateCasoAPI();
            await executeManagePost(api, payload, successObtenerResponsableCasoCallback);
        }
    }

    const successObtenerResponsableCasoCallback = ({data}) => {
        setResponsable({...data})
    }

    const obtenerNroSecciones = async () => {
        const payload ={
            "IdCuadroSede": idCuadroSede,
            "IdGrado": formValuesCaso[CASO_KEYS.IdReferenciaEntidad],
        }
        const api = cuadroRequerimientosGetNroSeccionesByGradoAPI();
        await executeManagePost(api, payload, successObtenerNroSeccionesCallback);
    }

    const successObtenerNroSeccionesCallback = ({data}) => {
        setFormValuesCaso(lastData => ({
            ...lastData,
            [CASO_KEYS.ParametroValor]: data?.NroSecciones,
        }));
    }

  const [selectProps] = usePropsSelect(
    allDropdowns,
    formValuesCaso,
    setFormValuesCaso,
    SECTION_NAME,
  );
 

  const tipoRefValue = formValuesCaso[CASO_KEYS.TipoReferencia];
  const { opciones, cargando, buscar } = useReferenciaSearch(
    idCuadroSede,
    tipoRefValue,
     formValuesCaso[CASO_KEYS.TipoCaso] === TIPO_CASOS.CargaHoraria
  );

  const referenciaSeleccionada = formValuesCaso[CASO_KEYS.Referencia]
    ? {
        value: formValuesCaso[CASO_KEYS.Referencia],
        label: formValuesCaso[CASO_KEYS.Referencia],
      }
    : null;

  const handleReferenciaChange = (selectedOption) => {
    setFormValuesCaso((prev) => ({
      ...prev,
      [CASO_KEYS.Referencia]: selectedOption?.value ?? "",
      [CASO_KEYS.IdReferenciaEntidad]: selectedOption?.id ?? null,
    }));
  };


    const labelReferencia =
        tipoRefValue === TIPO_REFERENCIA.Colaborador
            ? "Referencia (Colaborador)"
            : tipoRefValue === TIPO_REFERENCIA.Docente
                ? "Referencia (Docente)"
                : tipoRefValue === TIPO_REFERENCIA.Bloque
                    ? "Referencia (Bloque / Curso)"
                    : "Referencia";

    const placeholderReferencia =
        tipoRefValue === TIPO_REFERENCIA.Colaborador
            ? "Buscar colaborador..."
            : tipoRefValue === TIPO_REFERENCIA.Docente
                ? "Buscar docente..."
                : tipoRefValue === TIPO_REFERENCIA.Bloque
                    ? "Buscar curso..."
                    : "Seleccionar tipo de referencia primero";


  return (
    <>

      <Div col={12}>
        <InputText
          label="Tema"
          name="Tema"
          {...commonProps(CASO_KEYS.Tema)}
          sectionName={SECTION_NAME}
          direction="column"
          isRequired={true}
          isDisabled={!isEditable}
        />
      </Div>


      <Div col={6}>
        <InputSelect
          label="Tipo Caso"
          {...selectProps(CASO_KEYS.TipoCaso)}
          options={
              (dataToCreateCaso?.IdEstadoCuadroSede === estados.Enviado.id ||
               dataToCreateCaso?.IdEstadoCuadroSede === estados.Observado.id ) ?
                  handleFind(allDropdowns, CASO_KEYS.TipoCaso) :
                  handleFind(allDropdowns, CASO_KEYS.TipoCaso)?.filter(o => o.value !== "Observación")
          }
          sectionName={SECTION_NAME}
          isDisabled={!isEditable}
          isRequired={true}
          placeholder="Seleccionar tipo"
          direction="column"
        />
      </Div>
      <Div col={6}>
        <InputText
          label="Fecha"
          name="Fecha"
          value={new Date().toLocaleDateString("es-PE")}
          onChange={() => {}}
          sectionName={SECTION_NAME}
          isDisabled={true}
          direction="column"
        />
      </Div>


      <Div col={6}>
        <InputText
          label="Responsable"
          name="Responsable"
          value={responsable?.EmpleadoResponsable ?? ""}
          onChange={() => {}}
          sectionName={SECTION_NAME}
          direction="column"
          isDisabled={true}
          placeholder={"-"}
        />
      </Div>
      <Div col={6}>
        <InputSelect
          label="Estado"
          {...selectProps(CASO_KEYS.EstadoCaso)}
          value={(() => {
            const estadoMostrado = formValuesCaso[CASO_KEYS.TipoCaso] === TIPO_CASOS.CargaHoraria ? "Activo" : "Pendiente";
            return { value: estadoMostrado, label: estadoMostrado };
          })()}
          sectionName={SECTION_NAME}
          isDisabled={true}
          direction="column"
          isRequired={true}
        />
      </Div>


      <Div col={6}>
        <InputSelect
          label="Tipo Referencia"
          {...selectProps(CASO_KEYS.TipoReferencia)}
          options={
              formValuesCaso[CASO_KEYS.TipoCaso] === TIPO_CASOS.CargaHoraria ?
                  handleFind(allDropdowns, CASO_KEYS.TipoReferencia)
                      .filter(o =>
                          o.value === TIPO_REFERENCIA.Colaborador ||
                          o.value === TIPO_REFERENCIA.Vacante) :
                  formValuesCaso[CASO_KEYS.TipoCaso] === TIPO_CASOS.AlertaConfiguracion ?
                      handleFind(allDropdowns, CASO_KEYS.TipoReferencia)
                          .filter(o =>
                              o.value === TIPO_REFERENCIA.Grado) :
                      (formValuesCaso[CASO_KEYS.TipoCaso] === TIPO_CASOS.Nota || formValuesCaso[CASO_KEYS.TipoCaso] === TIPO_CASOS.SolicitudCambio) ?
                          handleFind(allDropdowns, CASO_KEYS.TipoReferencia)
                              .filter(o =>
                                  o.value === TIPO_REFERENCIA.Colaborador ||
                                  o.value === TIPO_REFERENCIA.Bloque) :
                          handleFind(allDropdowns, CASO_KEYS.TipoReferencia)
                              ?.filter(o =>
                                  o.value !== TIPO_REFERENCIA.Grado &&
                                  o.value !== TIPO_REFERENCIA.Vacante)
          }
          sectionName={SECTION_NAME}
          isDisabled={!isEditable}
          placeholder="Seleccionar"
          direction="column"
          isRequired={true}
        />
      </Div>


      <Div col={6}>
          <div className="input-form-column">

              <label
                  style={{
                      color: "#0367a6",
                      fontWeight: 500,
                      marginBottom: 4,
                      display: "block",
                  }}
              >
                  {labelReferencia}
              </label>

              <Select
                  placeholder={placeholderReferencia}
                  options={opciones}
                  value={referenciaSeleccionada}
                  onChange={handleReferenciaChange}
                  onInputChange={(inputValue) => buscar(inputValue)}
                  isLoading={cargando}
                  isDisabled={!isEditable || !tipoRefValue}
                  isClearable
                  filterOption={() => true}
                  noOptionsMessage={({ inputValue }) =>
                      !inputValue || inputValue.length < 2
                          ? "Escribe al menos 2 caracteres"
                          : "Sin resultados"
                  }
                  loadingMessage={() => "Buscando..."}
                  styles={selectReferenciaStyle}
                  isRequired={true}
                  name={CASO_KEYS.Referencia}
              />
              <p
                  className="ficha-form-input-validation-message"
                  id={`ficha-edit-${SECTION_NAME}-${CASO_KEYS.Referencia}-validation-message`}
              ></p>
          </div>



      </Div>


      {formValuesCaso[CASO_KEYS.TipoCaso] === "Carga Horaria" && (
        <Div col={6}>
            <div className="input-form-column">
                <label
                    style={{
                        color: "#0367a6",
                        fontWeight: 500,
                        marginBottom: 4,
                        display: "block",
                    }}
                >
                    Plaza
                </label>
                <Select
                    {...commonProps(CASO_KEYS.ParametroValor)}
                    sectionName={SECTION_NAME}
                    direction="column"
                    isDisabled={!isEditable}
                    isRequired={true}
                    options={[
                        { value: "0.2", label: "0.2" },
                        { value: "0.4", label: "0.4" },
                        { value: "0.6", label: "0.6" },
                        { value: "0.8", label: "0.8" },
                        { value: "1.0", label: "1.0" },
                    ]}
                    onChange={(selectedOption) => {
                        setFormValuesCaso((prev) => ({
                            ...prev,
                            [CASO_KEYS.ParametroValor]: selectedOption.value,
                        }));
                    }}
                    value={
                        formValuesCaso[CASO_KEYS.ParametroValor]
                            ? {
                                value: formValuesCaso[CASO_KEYS.ParametroValor],
                                label: formValuesCaso[CASO_KEYS.ParametroValor],
                            }
                            : null
                    }
                    placeholder="Seleccionar plaza"
                />
                <p
                    className="ficha-form-input-validation-message"
                    id={`ficha-edit-${SECTION_NAME}-${CASO_KEYS.ParametroValor}-validation-message`}
                ></p>
            </div>

        </Div>
      )}


        {formValuesCaso[CASO_KEYS.TipoCaso] === "Alerta de Configuración" && (
            <Div col={6}>
                <div className="input-form-column">
                    <InputNumber
                        label="Sección"
                        {...commonProps(CASO_KEYS.ParametroValor)}
                        sectionName={SECTION_NAME}
                        direction="column"
                    />
                    <p
                        className="ficha-form-input-validation-message"
                        id={`ficha-edit-${SECTION_NAME}-${CASO_KEYS.ParametroValor}-validation-message`}
                    ></p>
                </div>

            </Div>
        )}


      <Div col={12}>
        <InputTextArea
          label="Mensaje Inicial / Detalle"
          name="MensajeInicial"
          {...commonProps(CASO_KEYS.MensajeInicial)}
          sectionName={SECTION_NAME}
          direction="column"
          isRequired={true}
          isDisabled={!isEditable}
          placeholder="Escribe aquí el detalle de tu nota, observación o solicitud..."
          rows = {3}
        />
      </Div>
    </>
  );
};

export default CasoFormFields;
